
export const REQUIRED_ORG_FIELDS = [
    { key: "name", label: "Organization Name" },
    // { key: "description", label: "Description" },
    { key: "logo", label: "Logo" },
    {key: "logo_dark", label: "Logo Dark"},
    { key: "primary_phone", label: "Primary Phone" },
    { key: "primary_email", label: "Primary Email" },

];

export function getIncompleteFields(organization) {
    if (!organization) return [];
    
    return REQUIRED_ORG_FIELDS.filter((field) => {
        const value = organization[field.key];
        return !value || (typeof value === 'string' && value.trim() === '');
    });
}

export function isProfileComplete(organization) {
    return getIncompleteFields(organization).length === 0;
}

export function getMissingFieldsLabel(incompleteFields) {
    if (incompleteFields.length === 0) return '';
    if (incompleteFields.length === 1) return incompleteFields[0].label;
    if (incompleteFields.length === 2) {
        return `${incompleteFields[0].label} and ${incompleteFields[1].label}`;
    }
    return `${incompleteFields[0].label} and ${incompleteFields.length - 1} more`;
}
